import { render, staticRenderFns } from "./IcoolIcon.vue?vue&type=template&id=20be823f&scoped=true&"
import script from "./IcoolIcon.vue?vue&type=script&lang=js&"
export * from "./IcoolIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be823f",
  null
  
)

export default component.exports